<template>
  <div class="row" @click="goToEventShow()" style="cursor: pointer;">
    <div class="col-lg-3 offset-lg-1 col-md-6">
      <div v-if="event.image_url" class="item-image">
        <div v-if="event.sold_out" class="item-badges">
          <div class="item-badge-left">SOLD OUT</div>
        </div>
        <img :src="event.image_url" class="img-fluid">
      </div>

      <div v-else class="text-center">
        <i class="fa fa-picture-o" style="font-size: 10em;" aria-hidden="true"></i>
      </div>
    </div>

    <div class="col-lg-8 col-md-6">
      <div class="row">
        <div class="col-lg-7 col-md-12">
          <h3 class="item-title item-title-custom"
            :style="'color: ' + siteConfiguration.event_time_color || '#000'">
            <font>
              {{ getDayMoment(event) }}
            </font>
          </h3>
          <h3 class="item-title" :style="'color: ' + siteConfiguration.event_title_color || '#000'">
            {{ event.title }}
          </h3>
          <div v-html="getEventDate(event)" class="item-actions item-action-custom"
            :style="'color: ' + siteConfiguration.event_details_color || '#000'">
          </div>
          <div class="item-location item-location-custom">
            <div v-html="getEventFullAddress(event)"
              :style="'color: ' + siteConfiguration.event_details_color || '#000'">
            </div>
          </div>
        </div>

        <div class="col-lg-5 col-md-12">
          <h4 class="item-title item-title-custom"
            :style="'color: ' + siteConfiguration.event_time_color || '#000'">
            {{ getEventMoment() }}
          </h4>
          <div v-if="event.sold_out" class="item-location item-location-custom"
            :style="'color: ' + siteConfiguration.event_details_color || '#000'">
            <strong> SOLD OUT </strong>
          </div>
          <div v-if="showRemainingTickets(event) && !event.sold_out" class="item-location item-location-custom"
            :style="'color: ' + siteConfiguration.event_details_color || '#000'">
            <strong> {{ remainingTickets(event.remaining_tickets) }} </strong>
          </div>
          <div class="item-location item-location-custom d-none d-sm-block"
            :style="'color: ' + siteConfiguration.event_details_color || '#000'">
            {{ getAgeRestriction(event) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomEventRow',
  props: {
    event: {
      required: true,
      type: Object
    },
    siteConfiguration: {
      required: false,
      type: Object
    }
  },
  data: () => {
    return { }
  },
  methods: {
    getAgeRestriction (event) {
      let ageRestriction = null

      if (event.age_restriction === 18) {
        ageRestriction = 'Age 18+'
      } else if (event.age_restriction === 21) {
        ageRestriction = 'Age 21+'
      } else {
        ageRestriction = 'Age (All)'
      }

      return ageRestriction
    },
    getDayMoment (event) {
      var today = this.moment().endOf('day')
      var tomorrow = this.moment().add(1, 'day').endOf('day')
      var thisWeek = this.moment().endOf('week')
      var nextWeek = this.moment().add(1, 'weeks').endOf('week')
      var thisMonth = this.moment().endOf('month')
      var nextMonth = this.moment().add(1, 'month').endOf('month')
      var eventDate = this.moment(event.event_dates_attributes[0].starts_at)

      if (eventDate <= today) return 'Today'
      if (eventDate <= tomorrow) return 'Tomorrow'
      if (eventDate > tomorrow && eventDate <= thisWeek) return 'This week'
      if (eventDate > thisWeek && eventDate <= nextWeek) return 'Next week'
      if (eventDate > nextWeek && eventDate <= thisMonth) return 'This month'
      if (eventDate > thisMonth && eventDate <= nextMonth) return 'Next month'
      return ''
    },
    getEventMoment () {
      if (this.event.event_time && this.event.event_time.length > 0) {
        var eventTime = this.event.event_time
        eventTime = eventTime.charAt(0).toUpperCase() + eventTime.slice(1) + ' show'

        return eventTime
      }
    },
    goToEventShow () {
      let eventTitle = this.encodeEventTitle(this.event.title)

      this.$router.push({ name: 'customEventShow',
        params: {
          id: this.event.id,
          event_title: eventTitle
        }
      })
    }
  }
}
</script>
